import { render } from "./UserStuff.vue?vue&type=template&id=22f35cac"
import script from "./UserStuff.vue?vue&type=script&lang=ts"
export * from "./UserStuff.vue?vue&type=script&lang=ts"
script.render = render

export default script